$(document).ready(function () {
  let path = '';
  let history = ['1'];
  let answers = {};

  function updateStep(step) {
    $('.bsq-step-content').removeClass('active');
    $(`.bsq-step-content[data-step="${step}"]`).addClass('active');

    $('.bsq-step').removeClass("active");
    $(`.bsq-step[data-step="${history.length - 1}"]`).addClass('complete');
    $(`.bsq-step[data-step="${history.length}"]`).addClass('active');

    // $('.bsq-back').prop('disabled', history.length === 1);
    $('.bsq-next').prop('disabled', !$(`.bsq-step-content[data-step="${step}"] input:checked`).length);

    if(step == 'share-2' || step == 'solo-2') {
      $('.bsq-next').text('FINISH');
    } else {
      $('.bsq-next').text('Next');
    }
  }

  $('.bsq-choice input').on('change', function () {
    $('.bsq-choice', $(this).closest('.bsq-step-content')).removeClass('active');
    $(this).parent().addClass('active');
    $('.bsq-next').prop('disabled', false);

    let step = $(this).closest('.bsq-step-content').data('step');
    let value = $(this).val();
    answers[step] = value;

    $('.bsq-back').prop('disabled', history.length === 1);
  });

  $('.bsq-next').on('click', function () {
    let current = history[history.length - 1];
    let nextStep;

    if (current === '1') {
      path = answers['1'];
      if (path === 'solo') {
        nextStep = 'solo-2';
      } else if (path === 'share') {
        nextStep = 'share-2';
      }
    }

    if (nextStep) {
      history.push(nextStep);
      updateStep(nextStep);
    } else {
      let product = getResultProduct();
      showResult(product);
    }
  });

  $('.bsq-back').on('click', function () {
    if (history.length > 1) {
      history.pop();
      updateStep(history[history.length - 1]);
    }
  });

  const productMap = [
    {
      condition: (ans) => ans['1'] === 'solo' && ans['solo-2'] === 'yes',
      handle: 'full-bedsheet',
      title: 'Full Bedsheet',
      subline1: "Whole Bed harmony",
      subline2: "For solo use, full mattress coverage"
    },
    {
      condition: (ans) => ans['1'] === 'solo' && ans['solo-2'] === 'no',
      handle: 'oneside-bedsheet',
      title: 'One Side Bedsheet',
      subline1: "Solo comfort",
      subline2: "For partners where only one wants temp control"
    },
    {
      condition: (ans) => ans['1'] === 'share' && ans['share-2'] === 'yes',
      handle: 'full-bedsheet',
      title: 'Full Bedsheet',
      subline1: "Whole Bed harmony",
      subline2: "For solo use, full mattress coverage"
    },
    {
      condition: (ans) => ans['1'] === 'share' && ans['share-2'] === 'no',
      handle: 'bothside-bedsheet',
      title: 'Both Side Bedsheet',
      subline1: "Dual-Zone comfort",
      subline2: "For partners who want temp control for each side"
    }
  ];

  function getResultProduct() {
    for (let rule of productMap) {
      if (rule.condition(answers)) {
        return rule;
      }
    }

    return { handle: 'default-model', title: 'Default Model' };
  }

  function showResult(product) {
    $('.bsq-quiz-wrapper').removeClass('show').addClass('hide');
    $('.result-items').removeClass('show').addClass('hide');

    $('.bsq-progress-wrapper, .bsq-questions, .bsq-footer').addClass('hide');

    const $matched = $(`.result-items[data-product="${product.handle}"]`);
    $matched.removeClass('hide').addClass('show');

    $('#subline-1').text(product.subline1);
    $('#subline-2').text(product.subline2);

    $('.result-recommendation-wrapper').addClass('active');

    if (product.handle === "full-bedsheet") {
      $matched.find('.bsq-size-options input[value="superking"]').closest('label').hide();
    } else {
      $matched.find('.bsq-size-options input[value="superking"]').closest('label').show();
    }
  }

  function getAnswers() {
    return answers;
  }

  updateStep('1');

  window.bsqGetAnswers = getAnswers;
  window.bsqGetResultProduct = getResultProduct;


  $(document).on('click', '.add-bedsheet', function() {
    var variantId = $(this).parents('.result-item-variants').find('.result-item-choice input:checked').val();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: variantId, quantity: 1 },
      dataType: 'json',
      success: function (response) {
        console.log('Added to basket!', response);
      },
      error: function (error) {
        alert('Something went wrong!', error);
      }
    });
  });

  $('.result-item-choice input').on('change', function () {
    const atcText = $(this).parents('.result-item-variants').find('button').attr('data-atc-text');
    const available = $(this).parent().attr('data-available');

    $('.result-item-choice').removeClass('active');
    $(this).parent().addClass('active');
    if(available == 'false') {
      $(this).parents('.result-item-variants').find('button').attr('disabled', 'disabled');
      $(this).parents('.result-item-variants').find('button').addClass('sold-out');
      $(this).parents('.result-item-variants').find('button').text('Sold Out');
    } else {
      $(this).parents('.result-item-variants').find('button').removeAttr('disabled');
      $(this).parents('.result-item-variants').find('button').text(atcText);
      $(this).parents('.result-item-variants').find('button').removeClass('sold-out');
    }
  });
});